module.exports = __webpack_public_path__ + "img/Vehi╠üculo-Premiun.f4f86f5a.png";